module.exports = __webpack_public_path__ + "static/img/3.8e51565.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/3.png
// module id = kEdS
// module chunks = 0